import { render, staticRenderFns } from "./PayrollPercepts.vue?vue&type=template&id=e669c1aa&scoped=true&"
import script from "./PayrollPercepts.vue?vue&type=script&lang=js&"
export * from "./PayrollPercepts.vue?vue&type=script&lang=js&"
import style0 from "./PayrollPercepts.vue?vue&type=style&index=0&id=e669c1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e669c1aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e669c1aa')) {
      api.createRecord('e669c1aa', component.options)
    } else {
      api.reload('e669c1aa', component.options)
    }
    module.hot.accept("./PayrollPercepts.vue?vue&type=template&id=e669c1aa&scoped=true&", function () {
      api.rerender('e669c1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Payroll/PayrollPercepts.vue"
export default component.exports